import styled from 'styled-components';

import { ThemeProp } from '~/theme/Themes';

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0.5rem 0;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
`;

export const IconTile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* 10% tint of primary.c400 (#329AFC) — no dedicated token. */
  background: rgba(50, 154, 252, 0.1);
  padding: 0.5rem;
  border-radius: 0.25rem;
  flex-shrink: 0;
  color: ${({ theme }: ThemeProp) => theme.colors.primary.c400};

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const RowTitle = styled.p`
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.medium};
  color: ${({ theme }: ThemeProp) => theme.colors.neutrals.black};
  margin: 0;
`;

export const RowBody = styled.p`
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  line-height: ${({ theme }: ThemeProp) => theme.lineHeight.xs};
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.regular};
  color: ${({ theme }: ThemeProp) => theme.colors.neutrals.black};
  margin: 0;
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 0.5rem;
`;
